function searchaniseIgnoreOosToEnd() {

/*
MODIFICATION IS PROVIDED BY SEARCHANISE TEAM. WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

This modification allows ignoring Out-of-stock products to end sorting in specified collections. 
Collections are specified inside collectionsToExclude variable. 
Collections are specified via handles.

Here is an example of the expected format: 

let collectionsToExclude = [
    "new-arrivals",
    "summer-sale"
];

You can quickly disable the modification by changing the isEnabled variable value from true to false:
let isEnabled = false;

*/

// SETTINGS START

let isEnabled = true;

let collectionsToExclude = [
    "installation-sound-and-pa-systems",
];

// SETTINGS END. DO NOT EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        
        if (!isEnabled || isEnabled === 'false') { return }
        
        $(document).on('Searchanise.DataRequestBefore', function(event, type, params) {
            if (params && params.collection && collectionsToExclude.includes(params.collection)) {
                params.ignore_oos_to_end = 'true';
            }
        });
    })(window.Searchanise.$);
});

}

searchaniseIgnoreOosToEnd();